import styled from "styled-components";

const MainContainer = styled.div`
	max-width: 1600px;
	width: 85%;
	margin: 0 auto;

	@media (max-width: 800px) {
		width: 90%;
	}
`;

export default MainContainer;
